import Vue from 'vue';
import { mapGetters } from 'vuex';
import { tabShape } from '../../utils';

export default Vue.component('edit-tabs', {
  template: require('./template.html'),
  computed: {
    ...mapGetters(['viewport']),
    minCount() {
      const total = this.droplet.tabs.length;
      let disableClass = false;
      if (total <= 2) {
        disableClass = true;
      }
      return disableClass;
    },
    maxCount() {
      const total = this.droplet.tabs.length;
      let disableClass = false;
      if (total >= 10) {
        disableClass = true;
      }
      return disableClass;
    },
  },
  name: 'edit-tabs',
  props: ['droplet', 'show-edit-bubble'],
  methods: {
    addTab() {
      const total = this.droplet.tabs.length;
      if (total < 10) {
        const newTab = tabShape()();
        const payload = {};
        payload.drp = this.droplet;
        payload.newTab = newTab;
        this.promise(this.$store.dispatch('addNewTab', payload), 'adding tab');
      }
    },
    removeTab(i) {
      const total = this.droplet.tabs.length;
      if (total > 2) {
        const payload = {};
        payload.drp = this.droplet;
        payload.tabIndex = i;
        this.promise(this.$store.dispatch('removeTab', payload), 'removing section');
      }
    },
    setLayout(e) {
      const left = e.currentTarget.checked;
      let layout = 'top';
      if (left) {
        layout = 'left';
      }
      const payload = {};
      payload.drp = this.droplet;
      payload.layout = layout;
      this.promise(this.$store.dispatch('setTabLayout', payload), 'setting layout');
    },
    setLocals(v) {
      this.$emit('set-display', v);
    },
    bouncePlugin() {
      this.$vnode.context.unBindPlugin();
      this.$vnode.context.bindPlugin();
    },
    drzRevertData() {
      // rebind plugin in case user removed sections then cancelled.
      this.$emit('css-generator');
      this.bouncePlugin();
    },
    getTitle(html) {
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      return wrap.textContent;
    },
    promise(action, error) {
      const promise = new Promise((resolve, reject) => {
        if (action) {
          resolve();
        } else {
          reject(Error(`Error in Tabs: ${error}`));
        }
      });
      promise.then(() => {
        this.bouncePlugin();
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/tabs/components/_edit-options/index.js